import { render, staticRenderFns } from "./CustomerWithCreate.vue?vue&type=template&id=705e39c0&"
import script from "./CustomerWithCreate.vue?vue&type=script&lang=js&"
export * from "./CustomerWithCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports